import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../../action';
import * as c from '../../constant';
import NewDeclarationModal from './components/NewDeclarationModal';
import SubdivisionModal from './components/SubdivisionModal';
import ConsolidationModal from './components/ConsolidationModal';
import DisputeModal from './components/DisputeModal';
import TransferOwnershipModal from './components/TransferOwnershipModal';
import PhysicalChangeModal from './components/PhysicalChangeModal';
import DestructionModal from './components/DestructionModal';
import ReclassificationModal from './components/ReclassificationModal';

function TransactionModal({
  getTransactionCodesList,
  transactionList,
  ordinanceRevisionId
}) {

  useEffect(() => {
    getTransactionCodesList();
  }, []);

  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({
    rptax_transaction_code_id: '',
  });

  const validateForm = useFormValidator(formData, {
    rptax_transaction_code_id: 'required',
  });

  const handleOnSubmit = e => {
    e.preventDefault();

    switch (formData.rptax_transaction_code_id) {
      case "1":
        return setModal({
          isOpen: true,
          content: <NewDeclarationModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" ordinanceRevisionId={+ordinanceRevisionId} />,
          title: 'New Declaration (Discovery) Transaction',
          modalSize: 'modal-xl',
        });
      case "2":
        return setModal({
          isOpen: true,
          content: <SubdivisionModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" />,
          title: 'Subdivision',
          modalSize: 'modal-xl',
        });
      case "3":
        return setModal({
          isOpen: true,
          content: <ConsolidationModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" />,
          title: 'Consolidation',
          modalSize: 'modal-xl',
        });
      case "4":
        return setModal({
          isOpen: true,
          content: <DisputeModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" />,
          title: 'Dispute',
          modalSize: 'modal-xl',
        });
      case "5":
        return setModal({
          isOpen: true,
          content: <TransferOwnershipModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" />,
          title: 'Transfer of Ownership',
          modalSize: 'modal-xl',
        });
      case "10":
        return setModal({
          isOpen: true,
          content: <PhysicalChangeModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" />,
          title: 'Physical Change',
          modalSize: 'modal-xl',
        });
      case "12":
        return setModal({
          isOpen: true,
          content: <DestructionModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" />,
          title: 'Destruction',
          modalSize: 'modal-xl',
        });
      case "13":
        return setModal({
          isOpen: true,
          content: <ReclassificationModal transactionCode={parseInt(formData.rptax_transaction_code_id, 10)} modalType="NEW" />,
          title: 'Reclassification',
          modalSize: 'modal-xl',
        });
      default:
        return "";
    }
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const createDropdownRpt = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
        code: data.attributes.code,
      });
    });
    return newList;
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Select Transaction Code {validateForm.renderMessage('rptax_transaction_code_id')}
          </label>
          <Select
            options={createDropdownRpt(transactionList)}
            value={
              createDropdownRpt(transactionList).find(
                item => _.get(formData, 'rptax_transaction_code_id') === _.get(item, 'value')
              ) || ''
            }
            onChange={handleOnChangeSelect('rptax_transaction_code_id')}
          />
        </div>
      </div>
      <hr className='below-hr' />
      <div className="d-flex justify-content-center">
        <button
          disabled={!validateForm.response.is_passed}
          onClick={handleOnSubmit}
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
        >
          <span className="font-weight-bold">
            Proceed
          </span>
        </button>
      </div>
    </Modal.Body>
  );
}

TransactionModal.propTypes = {
  getTransactionCodesList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION_CODES}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransactionModal);